import { FC } from 'react';
import Breadcrumb from 'components/commercetools-ui/molecules/Breadcrumb';

interface AmplienceHeroBannerProps {
  breadcrumbs: Array<{ label: string; url: string }>;
}

const AmplienceBreadcrumbs: FC<AmplienceHeroBannerProps> = ({ breadcrumbs }) => {
  const _breadcrumbs = breadcrumbs.map((e) => ({ label: e.label, slug: e.url }));

  const itemListElement = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: 'https://shadesoflight.com/',
    },
    ...breadcrumbs.map((breadcrumb, index) => ({
      '@type': 'ListItem',
      position: index + 2,
      name: breadcrumb.label?.toLocaleLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()),
      item:
        breadcrumb.url && typeof breadcrumb.url === 'string'
          ? breadcrumb.url.startsWith('//') || breadcrumb.url.startsWith('http')
            ? breadcrumb.url.startsWith('//')
              ? `https:${breadcrumb.url}`
              : breadcrumb.url
            : `https://shadesoflight.com/${breadcrumb.url}`
          : '',
    })),
  ];
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };

  return <Breadcrumb breadcrumbs={_breadcrumbs} structuredData={structuredData} />;
};

export default AmplienceBreadcrumbs;
